<template>
	<div class="vuecontainer" id="vuecontainer">
		<div class="loading" v-if="loadingshow"><i class="el-icon-loading"></i><div class="text">努力加载中</div></div>
		<router-view @loading="loading" @page="page" @_function="_function" :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
export default {
	name: 'app',
	data: function () {	
		return {
			_loading: "",
			loadingshow: false,
			group: Group,
			show_left_button: true,
			show_bottom_button: true,
		};
	},
	created: function () {
		var Th = this;
		console.log("vueapp-start-"+Date.now());
	},
	methods:{
		_function: function(content)
		{
			var Th = this;
			content.forEach(function (ele)
			{
				//统计
				if(ele=='tongji'){
					httpRequest("/r.json?t="+Math.random(), {});
				}
				//回到顶部
				if(ele=='scrollto'){
					window.scrollTo({ top: 0, left: 0});
				}
				if(ele=='show_new_url'){
					Th.showTanchuang("new_url");
				}
				if(ele=='show_tanchuang0'){
					Th.showTanchuang("tanchuang0");
				}
				if(ele=='show_tanchuang1'){
					Th.showTanchuang("tanchuang1");
				}
				if(ele=='show_tanchuang2'){
					Th.showTanchuang("tanchuang2");
				}
				//慢加载
				if(ele=='lozad'){
					setTimeout(() => {
						lazyLoadImageNew('.lozad', (image) => {  });
					}, 500);
				}
				//慢加载
				if(ele=='lazy-load'){
					setTimeout(() => {
						lazyLoadImage('.lazy-load', (image) => { });
					}, 500);
				}
				//解密文字
				if(ele=='decrypt'){
					setTimeout(() => {
						document.querySelectorAll('.decrypt').forEach(element => {
							const text = element.getAttribute('decrypt-text');
							if (text) {
								element.innerHTML = Decrypt(text);
							}
						});
					}, 500);
				}
				//打开
				if(ele=='loading_open'){
					Th.loading("open");
				}
				//关闭
				if(ele=='loading_close'){
					Th.loading("close");
				}
			});
		},
		hideTanchuang: function(id)
		{
			var Th = this;
			if (id) {
				var element = document.getElementById(id);
				if (element) {
					element.style.display = 'none';
					setCookie("is_tanchuang_" + Th.group.channel_id, 1, 1200);
				}
			}
		},
		showTanchuang: function(id, is_qiangzhi=false){
			var Th = this;
			var is_tanchuang = getCookie("is_tanchuang_" + Th.group.channel_id);

			if ((id && isEmpty(is_tanchuang)) || is_qiangzhi === true) {
				var element = document.getElementById(id);
				if (element) {
					element.style.display = 'block';
				}
			}
		},
		loading: function(type)
		{
			var Th = this;
			if(type=="open"){
				Th.loadingshow = true;
			}else{
				Th.loadingshow = false;
			}
		},
		page: function(name){
			var categoryItems = document.querySelectorAll('.menu-item[type="'+name+'"]');
			categoryItems.forEach(function(item) {
				item.classList.add('active');
			});

			var bottomButton = document.getElementById('bottom-button');
			if (bottomButton) {
				bottomButton.classList.remove('bottom-button-hide');
			}
			
			var leftButton = document.getElementById('left-button');
			if (leftButton) {
				leftButton.classList.remove('left-button-hide');
			}

			setTimeout(() => {
				const target = document.querySelector('.menu-item[type="'+name+'"]');
				if (target) {
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'nearest',   // ✅ 垂直方向：仅在必要时滚动
						inline: 'center'    // 水平方向：居中
					});
				}
			}, 500);
		}
	},
}
</script>